import type { Node, NodeProps } from '@xyflow/react';
import { ZfPill } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useRef } from 'react';
import { useShadowRootCustomStyles } from '../../../app/hooks/useShadowRootCustomStyles';
import { connectorNodeSize } from '../../config/constants';
import type { ConnectorNodeData } from '../../interfaces';
import { NodeHandlers } from './node-handlers';

type FamilyTreeConnectorNodeType = Node<ConnectorNodeData, 'familyTreeConnectorNode'>;

export const ConnectorNode: FunctionComponent<NodeProps<FamilyTreeConnectorNodeType>> = ({ data }) => {
    const pillRef = useRef<HTMLZfPillElement>(null);

    useShadowRootCustomStyles(
        pillRef,
        `.pill { width: ${connectorNodeSize.width}px !important; height: ${connectorNodeSize.height}px !important; justify-content: center !important; cursor: grab !important; }`,
    );

    return (
        <div>
            <ZfPill
                clickable={false}
                ref={pillRef}
                size="medium"
                color={['IS_SPOUSE_OF', 'IS_REGISTERED_PARTNER_OF'].includes(data.relationshipType) ? 'green' : 'yellow'}
            >
                {data.label}
            </ZfPill>
            <NodeHandlers usedHandles={data.usedHandles} isConnectorNode={true} />
        </div>
    );
};
